import React, { useState, useEffect, useRef } from 'react';

//Hooks
const Footer = () => {



    //----------------------------auth params localstorage---------------------------------------------------
    let machine = "";
    let business = "";
    let branchoffice = "";
    let logo = ""
    let params = false
    let token = undefined
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo')
    }
    if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {

    } else {
        params = true
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))


        //setBranchoffice(JSON.parse(localStorage.getItem('branchoffice')))
        machine = JSON.parse(localStorage.getItem('machine'));
        business = JSON.parse(localStorage.getItem("business"));
    }
    //---------------------------------------------------------------------------------------------------------



    const year = new Date().getFullYear();
    return (
        <>
            <footer className="mt-5 pt-5 pb-3">
                <div className="container">     
                    <div className="text-center text-muted small">
                        <div className='container gap-4 d-lg-flex justify-content-lg-between justify-content-between align-content-center align-items-center w-100 text-center text-secondary'>
                            <div className=''>
                                <small className='opacity-50'>
                                    <i class="uil uil-copyright"></i>{year} Smart eCommerce, {business.name}
                                </small>
                            </div>                            
                            <div>
                                <small className='opacity-50'>
                                    <i class="uil uil-bolt"></i> Powered by Smart Retail Group
                                </small>
                            </div>
                        </div>
                    </div>
                </div >
            </footer >


        </>
    )
}

export default Footer